import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Home from "./components/pages/HomeComponent";
import Login from "./components/pages/LoginComponent";
import StaffLoginComponent from "./components/pages/StaffLoginComponent";
import Register from "./components/pages/RegisterComponent"; 
import StaffRegister from "./components/pages/StaffRegisterComponent";
import DecisionComponent from "./components/pages/DecisionComponent";
import PrivateRoute from "./PrivateRoute";
import { Guard } from "./Guard";

import Header from "./components/layouts/Header";
import UserListing from "./components/pages/UserListing";
import CustomerListing from "./components/pages/admin/CustomerList";
import CompanyListing from "./components/pages/admin/CompanyList";
import ApplicationsList from "./components/pages/common/ApplicationsList";
import ReceivedDocumentsList from "./components/partials/ReceivedDocumentsList/ReceivedDocumentsList";
import CustomerDetails from "./components/pages/customer/CustomerDetailsComponent";
import { useDispatch, useSelector } from "react-redux";
import ForwardedDocs from "./components/partials/ForwardedDocs/ForwardedDocs";
import Tracking from "./components/partials/Tracking/Tracking";
import ApplicationTemplate from "./components/partials/ApplicationTemplate/ApplicationTemplate";
import Message from "./components/pages/common/Message";
import ChalaniListing from "./components/pages/common/ChalaniListing";
import ProgressReportListing from "./components/pages/common/ProgressReportListing";
import ProfileView from "./components/pages/ProfileComponent";
import Welcome from "./components/pages/WelcomeComponent";

function Routes() {
  const loginNotifier = useSelector((state) => state.userAuth.loginNotifier);
  return (
    <>
      <Header />
      <Switch>
        <Route
          exact
          path="/"
          component={Welcome} />
        <Guard path="/home" token="user-token"
          routeRedirect="/user/login"  component={DecisionComponent} />
        <Route path="/staff/login" component={StaffLoginComponent} />
        <Route path="/user/login" component={Login} />
        <Route path="/user/register" component={Register} />
       
        {/* <Route 
          path="/staff/register" component={StaffRegister}
        /> */}
        <Route path="/documents_received" component={ReceivedDocumentsList} />
        <Route path="/forwarded_docs" component={ForwardedDocs} />
        <Route path="/tracking" component={Tracking} />
       

        <Guard
          path="/customer-details/:id"
          token="user-token"
          routeRedirect="/user/login"
          component={CustomerDetails}
        />
        <Guard
          path="/customer-details/"
          token="user-token"
          routeRedirect="/user/login"
          component={CustomerDetails}
        />
        <Guard
          path="/users-list"
          token="user-token"
          routeRedirect="/user/login"
          component={UserListing}
        />
        <Guard
          path="/customers-list"
          token="user-token"
          routeRedirect="/user/login"
          component={CustomerListing}
        />
        <Guard
          path="/companies-list"
          token="user-token"
          routeRedirect="/user/login"
          component={CompanyListing}
        />
        <Guard
          path="/application-create/:id"
          token="user-token"
          routeRedirect="/user/login"
          component={ApplicationTemplate}
        />
        <Guard
          path="/applications-list/"
          token="user-token"
          routeRedirect="/user/login"
          component={ApplicationsList}
        />
        <Guard
          path="/tippani/"
          token="user-token"
          routeRedirect="/user/login"
          component={Message}
        />
        <Guard
          path="/application-status/"
          token="user-token"
          routeRedirect="/user/login"
          component={Message}
        />
        
        <Guard
          path="/profile/"
          token="user-token"
          routeRedirect="/user/login"
          component={ProfileView}
        />
        <Guard
          path="/chalani/"
          token="user-token"
          routeRedirect="/user/login"
          component={ChalaniListing}
        />
        <Guard
          path="/progress-report/"
          token="user-token"
          routeRedirect="/user/login"
          component={ProgressReportListing}
        />
        {/*Redirect if not authenticated */}

        <Guard
          path="/user"
          token="user-token"
          routeRedirect="/user/login"
          component={PrivateRoute}
        />
      </Switch>
    </>
  );
}

export default Routes;
